import {HttpErrorResponse, HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest} from "@angular/common/http";
import {Observable, retry, throwError, timer} from "rxjs";

const SEARCH_PATH_SUFFIX: string = '/search';
const MAX_RETRIES: number = 1;
const RETRY_BASE_DELAY_MS: number = 500;

/**
 * Retries read-only search/typeahead POSTs (URL path ends with `/search`) on transient failures.
 * These endpoints use POST only because of their large request body but are semantically reads,
 * so retrying them is safe. Only network errors (status 0) and 5xx are retried; 4xx responses are
 * passed through unchanged since a repeat would not change the outcome.
 */
export const searchRetryInterceptor: HttpInterceptorFn = (request: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> => {
  if (request.method !== 'POST' || !isSearchRequest(request)) {
    return next(request);
  }
  return next(request).pipe(retry({
    count: MAX_RETRIES,
    delay: (error, retryCount) => {
      if (isTransient(error)) {
        return timer(RETRY_BASE_DELAY_MS * retryCount); // linear back-off: 500ms, 1000ms
      }
      return throwError(() => error);
    }
  }));
};

const isSearchRequest = (request: HttpRequest<unknown>): boolean => {
  const path: string = request.url.split('?')[0];
  return path.endsWith(SEARCH_PATH_SUFFIX);
};

const isTransient = (error: unknown): boolean => {
  return error instanceof HttpErrorResponse && (error.status === 0 || error.status >= 500);
};
